import Vue from 'vue';

import store from './store';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


import alert from './components/alerts/AlertComponent.vue';
Vue.component('alert', alert);

import alertBridge from './components/bridge/AlertBridgeComponent.vue';
Vue.component('alert-bridge', alertBridge);

Vue.component('byo-listing', require('./components/byo-listing.vue').default);
Vue.component('activity-listing-item', require('./components/activity-listing-item.vue').default);
Vue.component('itinerary-item', require('./components/itinerary-item.vue').default);
Vue.component('activity-buttons', require('./components/activity-buttons.vue').default);
Vue.component('package-summary', require('./components/package-summary.vue').default);
Vue.component('build-summary', require('./components/build-summary.vue').default);
Vue.component('quote-form', require('./components/quote-form.vue').default);
Vue.component('claim-place', require('./components/claim-place.vue').default);
Vue.component('claim-form', require('./components/claim-form.vue').default);
Vue.component('participants', require('./components/participants.vue').default);
Vue.component('participant-form', require('./components/participant-form.vue').default);
Vue.component('payment-form', require('./components/payment-form.vue').default);
Vue.component('payment-button', require('./components/payment-button.vue').default);
Vue.component('messenger-button', require('./components/messenger-button.vue').default);
Vue.component('messenger', require('./components/messenger.vue').default);
Vue.component('addon-button', require('./components/addon-button.vue').default);
Vue.component('addons', require('./components/addons.vue').default);
Vue.component('edit-booking-button', require('./components/edit-booking-button.vue').default);
Vue.component('edit-booking', require('./components/edit-booking.vue').default);
Vue.component('questions', require('./components/questions.vue').default);
Vue.component('questions-button', require('./components/questions-button.vue').default);
Vue.component('form-field', require('./components/form-field.vue').default);
Vue.component('supplier-activity-buttons', require('./components/supplier-activity-buttons.vue').default);
Vue.component('supplier-activity-form', require('./components/supplier-activity-form.vue').default);


var elementExists = document.getElementById("app");
if (elementExists) {
	const app = new Vue({
		el: '#app',
		store: store
	});
}